import request from '@/utils/request'

// 获取对账单主数据
export function selectByStatementCode(statementCode) {
  return request({
    url: `/api/srm-finc/purStatement/selectByStatementCode/${statementCode}`,
    method: 'get'
  })
}

// 通过主表id查询明细表数据
export function detailPageByStatementCode(query) {
  return request({
    url: '/api/srm-finc/purStatementDetail/detailPageByStatementCode',
    method: 'get',
    params: query
  })
}
// 查询芯片不良品处理明细数据
export function detailChipPageByStatementCode(query) {
  return request({
    url: '/api/srm-finc/purStatementRejectsItem/queryRejectItem',
    method: 'get',
    params: query
  })
}
// 对账单采购核对节点，APP校验
export function checkInVerifyNode(statementCode) {
  return request({
    url: `/api/srm-finc/purStatement/checkInVerifyNode/${statementCode}`,
    method: 'get'
  })
}
